import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=2a368840"
import script from "./AppMain.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppMain.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=2a368840&prod&module=true&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports